export const NOTIFICATION_TYPE_SMS = 'email+sms';

export const NOTIFICATION_TYPES = [
  {
    id: 'email',
    name: 'Email'
  },
  {
    id: NOTIFICATION_TYPE_SMS,
    name: 'Email + SMS'
  }
];
